import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, Row, Table } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useCallback, useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../app/hooks';
import {} from '../../../../auth/states/userSlice';
import { setModal } from '../../../../common/slices/commonSlice';
import { IPermission } from '../../../../common/types/commonTypes';
import { debounce } from '../../../../common/utils/common.utils';
import { getRowHightLightClass } from '../../../../common/utils/rowColorChange';
import usePagination from '../../../../common/utils/usePagination';
import useUrlParams from '../../../../common/utils/useUrlParams';
import CommonTableHeader from '../../../../components/common/CommonTableHeader';
import { FormInput } from '../../../../components/common/FormItem/FormItems';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import Reload from '../../../../components/common/reload/Reload';
import { loadingIndicator } from '../../../../components/common/spinner/LoadingIndicator';
import { parseDateRangeObject } from '../../../../helpers/healper';
import { IAccountDataType } from '../../AccountsTypes/AccountsTypes';
import { useGetAccountsV2Query } from '../../Api/Endpoints/accountsEndpoints';
import AccountsAddModal from '../../modals/Add_ListOfAccounts/AccountsAddModal';
import AccountsEditModal from '../../modals/Add_ListOfAccounts/AccountsEditModal';
import { accountListColumns } from '../../utils/Add_ListOfAccounts/ListOfAccountsColumn';

type Props = { permission?: IPermission };

const Add_List_Accounts = ({ permission }: Props) => {
  const { setUrlParam, setUrlParamsFromObject, getAllUrlParams } = useUrlParams();
  const { page, size, changePagination, pagination } = usePagination();
  const params_value = getAllUrlParams() as {
    search: string | null;
    from_date: string | null;
    to_date: string | null;
  };
  const [columnIndex, setColumnIndex] = useState<number | null>(null);
  const dispatch = useAppDispatch();
  const [editInfo, setEditInfo] = useState<IAccountDataType | null>(null);

  const showModal = () => {
    dispatch(setModal(true));
  };

  const {
    data,
    isFetching,
    refetch,
    isLoading: dataIsLoading,
  } = useGetAccountsV2Query({
    ...getAllUrlParams(),
    page,
    size,
  });

  // ----------- tabel
  const column = accountListColumns({
    setEditInfo,
    showModal,
    permission,
    pagination,
  });

  const dataWithKey = data?.data?.map((item, index) => ({
    key: String(index),
    ...item,
  }));
  const [form] = useForm();

  const handelSearch = useCallback(
    debounce((e: string) => {
      setUrlParam('search', e);
    }, 500),
    []
  );

  useEffect(() => {
    form.setFieldsValue({
      search: params_value.search,
      date_range: parseDateRangeObject({
        from_date: params_value.from_date,
        to_date: params_value.to_date,
      }),
    });
  }, [params_value]);
  return (
    <>
      <BreadCrumb arrOfOption={['Accounts']} reloaderSize='small' />

      {/* <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 10 }}
        style={{ marginBottom: '25px' }}
        justify={'space-between'}
      >
        <Col span={12}>
          <Row justify={'start'} gutter={10}>
            {permission?.['create:any'] && (
              <Col>
                <Button type='primary' onClick={showModal}>
                  <PlusOutlined />
                  Add Account
                </Button>
              </Col>
            )}

            <Col style={{ display: 'flex' }}>
              <Col>
                <Reload
                  refetch={() => {
                    getAllAccounts();
                  }}
                />
              </Col>
            </Col>
          </Row>
        </Col>

        <Col span={12}>
          <Row justify={'end'} gutter={10}>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Input
                placeholder='🔍 Search Here...'
                onBlur={handleSearch}
                onPressEnter={handleSearch}
                allowClear
              ></Input>
            </Col>
          </Row>
        </Col>
      </Row> */}
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 10 }} justify={'space-between'}>
        <Col span={12}>
          <Row gutter={10}>
            {permission?.['create:any'] && (
              <Col xs={24} sm={12} md={8} lg={8}>
                <Button
                  onClick={showModal}
                  type='primary'
                  icon={<PlusOutlined />}
                  style={{ width: '100%' }}
                >
                  Create New Account
                </Button>
              </Col>
            )}

            <Col xs={24} sm={12} md={8} lg={8} style={{ display: 'flex' }}>
              <Col>
                <Reload
                  refetch={() => {
                    refetch();
                  }}
                />{' '}
              </Col>
            </Col>
          </Row>
        </Col>

        <Col span={12}>
          <Form form={form}>
            <Row justify={'end'} gutter={[10, 10]}>
              <FormInput
                name={'search'}
                placeholder='Search here ...'
                onChange={(e: string) => handelSearch(e.trim())}
              />
            </Row>
          </Form>
        </Col>
      </Row>
      <div>
        <span style={{ float: 'left', marginBottom: '1rem' }}>
          You have total <strong>{data?.count ? data?.count : data?.data?.length}</strong> rows
        </span>
        <Table
          size='small'
          bordered
          rowClassName={(item) => getRowHightLightClass(item.account_create_date)}
          columns={column}
          dataSource={dataWithKey}
          scroll={{ x: 'max-content' }}
          loading={{
            spinning: dataIsLoading || isFetching,
            indicator: loadingIndicator,
          }}
          pagination={changePagination(data?.count)}
        />
      </div>

      <CommonTableHeader
        modalTitle={editInfo ? 'Edit Account' : 'Add Account'}
        element={
          editInfo ? (
            <AccountsEditModal info={editInfo} setNull={setEditInfo} />
          ) : (
            <AccountsAddModal />
          )
        }
        setNull={setEditInfo}
      />
    </>
  );
};

export default Add_List_Accounts;
